import React, { useState } from 'react';
import Pagination from 'react-js-pagination';

const PaginatedDeviceSelectionTable = ({ 
  devices, 
  selectedDevices, 
  onDeviceSelect, 
  itemsPerPage = 5
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  
  // 计算总项目数
  const totalItemsCount = devices.length;
  
  // 获取当前页数据
  const getCurrentPageItems = () => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    return devices.slice(startIndex, endIndex);
  };

  // 处理页面变化
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <div>
      <div className="table-responsive" style={{ maxHeight: "350px", overflow: "auto" }}>
        <table className="table table-hover table-wrap" style={{ margin: "20px 0" }}>
          <thead>
            <tr>
              <th>Device Name</th>
              <th>Device S/N</th>
              <th>Select</th>
            </tr>
          </thead>
          <tbody>
            {getCurrentPageItems().map((device) => (
              <tr key={device.id}>
                <td>{device.name}</td>
                <td>{device.serialNo}</td>
                <td>
                  <input
                    type="checkbox"
                    checked={selectedDevices.includes(device.id)}
                    onChange={() => onDeviceSelect(device.id)}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      
      {/* 只有当项目数量足够时才显示分页器 */}
      {totalItemsCount > itemsPerPage && (
        <div style={{ 
          display: 'flex', 
          justifyContent: 'flex-end',
          marginTop: '10px',
          paddingRight: '10px',
        }}>
          <Pagination
            activePage={currentPage}
            itemsCountPerPage={itemsPerPage}
            totalItemsCount={totalItemsCount}
            pageRangeDisplayed={3}
            onChange={handlePageChange}
            itemClass="page-item"
            linkClass="page-link"
            innerClass="pagination pagination-sm mb-0"
          />
        </div>
      )}
    </div>
  );
};

export default PaginatedDeviceSelectionTable;